<template>
  <div class="dialog-launcher">
    <v-btn class="btn-leaf" @click="dialog = true">
      <v-icon left>mdi-plus</v-icon>Adaugă echipament
    </v-btn>
    <v-dialog v-model="dialog" persistent scrollable max-width="920" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-form class="fdlg__form" @submit.prevent="saveEquipment">
          <div class="fdlg__head">
            <div>
              <h2 class="fdlg__title">Echipament nou</h2>
              <p class="fdlg__sub">Câmpurile cu * sunt obligatorii.</p>
            </div>
            <v-btn icon aria-label="Închide" @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <v-card-text ref="body" class="fdlg__body">
            <section class="form-section">
              <div class="form-section__label"><v-icon small>mdi-desktop-classic</v-icon>Echipamentul</div>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="selectedType"
                    :items="typeOptions"
                    label="Tip echipament*"
                    item-text="type"
                    item-value="id"
                    prepend-inner-icon="mdi-shape-outline"
                    outlined
                    required
                    :error-messages="formErrors.selectedType"
                  ></v-select>
                </v-col>
                <!-- <v-col cols="12" sm="4">
                  <v-switch
                    v-model="isFunctional"
                    label="Echipamentul este activ"
                    inset
                    color="primary"
                  ></v-switch>
                </v-col> -->
                <v-col cols="12" sm="6">
                  <v-combobox
                    v-model="model"
                    :items="modelSuggestions"
                    :search-input.sync="modelSearch"
                    label="Model*"
                    :hint="modelSuggestions.length ? 'Alegeți din catalog sau scrieți modelul' : 'de exemplu: Samsung ML 2165'"
                    prepend-inner-icon="mdi-tag-outline"
                    outlined
                    :error-messages="formErrors.model"
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="registration"
                    :label="registrationIsOptional ? 'Nr. inventar (opțional)' : 'Nr. inventar*'"
                    hint="numărul de inventar al universității, de exemplu: 002921"
                    prepend-inner-icon="mdi-barcode"
                    outlined
                    required
                    :error-messages="formErrors.registration"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <SerialField ref="serial" v-model="serial" :error-messages="formErrors.serial" />
                </v-col>
              </v-row>
            </section>

            <section class="form-section">
              <div class="form-section__label"><v-icon small>mdi-account-tie-outline</v-icon>Responsabil și departament</div>
              <v-row dense>
                <v-col v-if="canPickOwner" cols="12">
                  <v-autocomplete
                    v-model="selectedUser"
                    :items="activeUsers"
                    label="Persoana responsabilă*"
                    item-text="user"
                    item-value="id"
                    prepend-inner-icon="mdi-account-outline"
                    outlined
                    required
                    :error-messages="formErrors.selectedUser"
                  ></v-autocomplete>
                </v-col>
                <v-col v-else cols="12">
                  <p class="form-section__note mt-0">Echipamentul va fi înregistrat pe numele dumneavoastră.</p>
                </v-col>
                <v-col cols="12">
                  <div class="dept-field">
                    <div class="dept-field__bar">
                      <span class="dept-field__label">Departamentul*</span>
                      <span class="dept-field__current">
                        <template v-if="selectedDepartment.length">
                          <v-icon small>mdi-check-circle-outline</v-icon>{{ selectedDepartment[0].name }}
                        </template>
                        <template v-else>bifați un singur departament</template>
                      </span>
                      <v-spacer></v-spacer>
                      <v-btn outlined small color="primary" @click="resetDepartment">
                        <v-icon left small>mdi-restore</v-icon>Resetează
                      </v-btn>
                    </div>
                    <div class="dept-field__tree">
                      <v-treeview
                        :value="selectedDepartment"
                        :items="departmentTree"
                        item-key="id"
                        item-text="name"
                        selectable
                        selection-type="independent"
                        return-object
                        dense
                        open-on-click
                        selected-color="primary"
                        aria-label="Departamentul"
                        @input="onDepartmentInput"
                      >
                        <template #label="{ item }">
                          {{ item.name }}<span v-if="item.hidden" class="tag-hidden">ascuns</span>
                        </template>
                      </v-treeview>
                    </div>
                  </div>
                  <div v-if="formErrors.selectedDepartment" class="form-error mt-2">
                    {{ formErrors.selectedDepartment }}
                  </div>
                  <p v-else-if="departmentHint" class="form-section__note mt-2 mb-0" data-note="department">
                    <v-icon small>mdi-information-outline</v-icon> {{ departmentHint }}
                  </p>
                </v-col>
              </v-row>
              <div class="mb-3"></div>
            </section>

            <section class="form-section">
              <div class="form-section__label"><v-icon small>mdi-map-marker-outline</v-icon>Locația</div>
              <v-row dense>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="selectedBlock"
                    :items="blocks"
                    label="Bloc*"
                    item-text="block"
                    item-value="block"
                    prepend-inner-icon="mdi-office-building-outline"
                    outlined
                    required
                    @change="onBlockChange"
                    :error-messages="formErrors.selectedBlock"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="selectedFloor"
                    :items="floors"
                    label="Etaj*"
                    item-text="floor"
                    item-value="floor"
                    prepend-inner-icon="mdi-stairs"
                    outlined
                    required
                    @change="onFloorChange"
                    :error-messages="formErrors.selectedFloor"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="selectedRoom"
                    :items="rooms"
                    label="Cameră*"
                    item-text="room"
                    item-value="room"
                    prepend-inner-icon="mdi-door"
                    outlined
                    required
                    :error-messages="formErrors.selectedRoom"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="locationDetails"
                    label="Detalii amplasare (opțional)"
                    hint="unde anume în cameră, de exemplu: hol, deasupra ușii 208"
                    prepend-inner-icon="mdi-map-marker-radius-outline"
                    outlined
                    counter="255"
                    maxlength="255"
                  ></v-text-field>
                </v-col>
              </v-row>
            </section>

            <ItemPhotosSection
              :label.sync="labelPhotos"
              :place.sync="placePhotos"
              @uploading="photosUploading = $event"
              @error="$emit('error', $event)"
            />
          </v-card-text>

          <div class="fdlg__foot">
            <v-spacer></v-spacer>
            <v-btn text large @click="closeDialog()">Anulare</v-btn>
            <v-btn class="btn-green" large type="submit" :loading="saving" :disabled="photosUploading">
              <v-icon left>mdi-content-save-outline</v-icon>Salvează
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as api from "./api";
import * as helper from "@/helper/helper";
import { mapGetters } from "vuex";
import { offeredTypes, offeredLocations, departmentTree, registrationOptional } from "./pickers";
import departmentHint from "./departmentHint";
import SerialField from "./SerialField.vue";
import ItemPhotosSection from "./ItemPhotosSection.vue";

export default {
  components: { SerialField, ItemPhotosSection },
  mixins: [departmentHint],
  data() {
    return {
      dialog: false,
      saving: false,
      serial: "",
      locationDetails: "",
      // uploaded already (pending on the server), linked by the save
      labelPhotos: [],
      placePhotos: [],
      photosUploading: false,
      types: [],
      users: [],
      departments: [],
      blocks: [],
      floors: [],
      rooms: [],
      model: "",
      // what is typed in the model box before it loses focus
      modelSearch: null,
      modelSuggestions: [],
      registration: "",
      location: "",
      selectedType: null,
      selectedUser: null,
      // isFunctional: true,
      selectedDepartment: [],
      selectedBlock: null,
      selectedFloor: null,
      selectedRoom: null,
      formErrors: {
        selectedUser: "",
        selectedType: "",
        model: "",
        registration: "",
        selectedBlock: "",
        selectedFloor: "",
        selectedRoom: "",
        selectedDepartment: "",
        serial: "",
      },
    };
  },
  computed: {
    ...mapGetters(["getUser", "isAdmin"]),
    // same people who can change the owner in the edit dialog
    canPickOwner() {
      return ["admin", "inginer", "inginer-pc", "dtisef"].includes(this.getUser.role);
    },
    typeOptions() {
      return offeredTypes(this.types);
    },
    // as the old „Nr. inventar / serie*”: one of them is enough (Inventariere and the import take neither, the
    // QR code identifies the item; editing never asks for a number)
    registrationIsOptional() {
      return registrationOptional(this.selectedType) || !!this.serial.trim();
    },
    // blocked accounts can't be given new equipment
    activeUsers() {
      return this.users.filter((u) => u.isActive !== false);
    },
    ownerId() {
      return this.canPickOwner ? this.selectedUser : this.getUser.userId;
    },
    departmentTree() {
      return departmentTree(this.departments);
    },
    // any department may be chosen (a sub-unit too); only a hint when the owner is not a member there
    hintOwnerId() {
      return this.ownerId;
    },
    hintDepartmentId() {
      return this.selectedDepartment.length ? this.selectedDepartment[0].id : null;
    },
    hintActive() {
      return this.dialog;
    },
  },
  methods: {
    async fetchData() {
      try {
        this.types = await api.fetchEquipmentTypes();
        this.users = await api.getUsersDropDown();
        this.departments = await api.getDepartments();
        this.blocks = helper.sortNatural(offeredLocations(await api.fetchBlocks()), "block");
      } catch (error) {
        console.error("Error fetching:", error);
        this.$emit("error", error);
      }
    },
    async loadModelSuggestions() {
      const typeId = this.selectedType;
      if (!typeId) {
        this.modelSuggestions = [];
        return;
      }
      try {
        const names = await api.getModelSuggestions(typeId);
        if (this.selectedType === typeId) this.modelSuggestions = names;
      } catch (error) {
        this.modelSuggestions = [];
      }
    },
    modelText() {
      const text = this.modelSearch != null ? this.modelSearch : this.model;
      return String(text || "").trim();
    },
    // one department: the node just ticked replaces the previous one
    onDepartmentInput(picked) {
      const currentId = this.selectedDepartment.length ? this.selectedDepartment[0].id : null;
      const added = picked.filter((d) => d.id !== currentId);
      this.selectedDepartment = added.length ? [added[added.length - 1]] : picked;
    },
    resetDepartment() {
      this.selectedDepartment = [];
      this.formErrors.selectedDepartment = "";
    },
    async saveEquipment() {
      if (this.saving || this.photosUploading) return;
      this.validateForm();

      if (!this.isFormValid()) {
        return;
      }

      let locationId;
      try {
        locationId = await api.getLocationIdByDetails(this.selectedBlock, this.selectedFloor, this.selectedRoom);
      } catch (error) {
        this.$emit("error", error);
        return;
      }
      if (!locationId) {
        this.formErrors.selectedRoom = "Locația (bloc / etaj / cameră) nu există. Reselectați camera.";
        return;
      }

      const postData = {
        equipment_type_id: this.selectedType,
        model: this.modelText(),
        registration_number: this.registration,
        responsible_person_id: this.canPickOwner
          ? this.selectedUser
          : this.getUser.userId,
        location_id: locationId,
        department_id:
          this.selectedDepartment.length > 0
            ? this.selectedDepartment[0].id
            : null,
        // isFunctional: this.isFunctional,
        serial_number: this.serial.trim() || null,
        location_details: this.locationDetails.trim() || null,
        label_file_id: this.labelPhotos.length ? this.labelPhotos[0].id : null,
        place_file_id: this.placePhotos.length ? this.placePhotos[0].id : null,
      };

      this.saving = true;
      try {
        await api.saveEquipmentData(postData);
        this.$emit("updateEquipmentData");
        this.$emit("success", "Echipamentul a fost adăugat");
        this.dialog = false;
        this.clearFields();
      } catch (error) {
        console.error("Error saving equipment:", error);
        const serialError = api.serialErrorMessage(error);
        if (serialError) {
          // under the field: the message names the item that has this seria
          this.formErrors.serial = serialError;
          this.$nextTick(() => this.$refs.serial && this.$refs.serial.$el.scrollIntoView({ behavior: "smooth", block: "center" }));
        } else {
          this.$emit("error", error);
        }
      } finally {
        this.saving = false;
      }
    },
    // A floor/room from the previous block is not valid in the new one (it saved a null location)
    onBlockChange() {
      this.selectedFloor = null;
      this.selectedRoom = null;
      this.floors = [];
      this.rooms = [];
      this.fetchFloors();
    },
    onFloorChange() {
      this.selectedRoom = null;
      this.rooms = [];
      this.fetchRooms();
    },
    async fetchFloors() {
      const block = this.selectedBlock;
      if (block) {
        try {
          const floors = offeredLocations(await api.getFloorsByBlock(block));
          // the block changed meanwhile
          if (this.selectedBlock === block) this.floors = floors;
        } catch (error) {
          console.error("Error fetching floors:", error);
          this.$emit("error", error);
        }
      } else {
        this.floors = [];
      }
    },
    async fetchRooms() {
      const { selectedBlock: block, selectedFloor: floor } = this;
      if (block && floor) {
        try {
          const rooms = offeredLocations(await api.getRoomsByBlockAndFloor(block, floor));
          if (this.selectedBlock === block && this.selectedFloor === floor) this.rooms = rooms;
        } catch (error) {
          console.error("Error fetching rooms:", error);
          this.$emit("error", error);
        }
      } else {
        this.rooms = [];
      }
    },
    isFormValid() {
      return !Object.values(this.formErrors).some((error) => error);
    },
    validateForm() {
      this.formErrors.selectedUser =
        this.canPickOwner && !this.selectedUser
          ? "Selectați o persoană responsabilă."
          : "";
      this.formErrors.selectedType = !this.selectedType
        ? "Selectați un tip de echipament."
        : "";
      this.formErrors.model = !this.modelText() ? "Introduceți un model." : "";
      this.formErrors.registration = !this.registration && !this.registrationIsOptional
        ? "Introduceți un număr de înregistrare."
        : "";
      this.formErrors.selectedBlock = !this.selectedBlock
        ? "Selectați un bloc."
        : "";
      this.formErrors.selectedFloor = !this.selectedFloor
        ? "Selectați un etaj."
        : "";
      this.formErrors.selectedRoom = !this.selectedRoom
        ? "Selectați o cameră."
        : "";
      this.formErrors.selectedDepartment = this.selectedDepartment.length !== 1
        ? "Alegeți departamentul."
        : "";
      this.formErrors.serial = this.$refs.serial ? this.$refs.serial.validate() : "";
    },
    closeDialog() {
      this.dialog = false;
      this.clearFields();
    },
    clearFields() {
      this.formErrors = {
        selectedUser: "",
        selectedType: "",
        model: "",
        registration: "",
        selectedBlock: "",
        selectedFloor: "",
        selectedRoom: "",
        selectedDepartment: "",
        serial: "",
      };
      this.serial = "";
      this.locationDetails = "";
      this.labelPhotos = [];
      this.placePhotos = [];
      this.selectedUser = null;
      this.selectedType = null;
      this.model = "";
      this.modelSearch = null;
      this.registration = "";
      this.selectedBlock = null;
      this.selectedFloor = null;
      this.selectedRoom = null;
      this.floors = [];
      this.rooms = [];
      this.selectedDepartment = [];
      // memberships can change in Utilizatori meanwhile: asked again at the next opening
      this.forgetMemberships();
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    selectedUser(newVal) {
      this.formErrors.selectedUser = "";
    },
    ownerId() {
      this.formErrors.selectedDepartment = "";
    },
    dialog(isOpen) {
      if (!isOpen) return;
      // the catalog may have changed in Configurare since the last opening
      this.loadModelSuggestions();
      helper.scrollToTop(this);
    },
    selectedType() {
      this.formErrors.selectedType = "";
      this.loadModelSuggestions();
    },
    model() {
      this.formErrors.model = "";
    },
    modelSearch() {
      this.formErrors.model = "";
    },
    registration(newVal) {
      this.formErrors.registration = "";
    },
    serial() {
      this.formErrors.serial = "";
    },
    selectedBlock(newVal) {
      this.formErrors.selectedBlock = "";
    },
    selectedFloor(newVal) {
      this.formErrors.selectedFloor = "";
    },
    selectedRoom(newVal) {
      this.formErrors.selectedRoom = "";
    },
    selectedDepartment() {
      this.formErrors.selectedDepartment = "";
    },
  },
};
</script>

<style scoped>
.dept-field {
  border: 1px solid #c3d0c9;
  border-radius: 10px;
  overflow: hidden;
}
.dept-field__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  padding: 8px 10px 8px 14px;
  background: var(--mint-50);
  border-bottom: 1px solid var(--line-soft);
}
.dept-field__label {
  font-weight: 700;
  color: var(--ink-2);
}
.dept-field__current {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ink-3);
}
.dept-field__current .v-icon {
  color: var(--green);
}
.dept-field__tree {
  max-height: 300px;
  overflow-y: auto;
  padding: 4px 0;
}
.tag-hidden {
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 999px;
  background: var(--slate-bg);
  color: var(--slate);
  font-size: 0.75rem;
  font-weight: 700;
}
</style>